import { IconProps } from "./types";

export const TableSortIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <g clipPath="url(#clip0_2415_796)">
        <path
          d="M12.0819 0.816102L2.28188 0.823088C1.11522 0.82392 0.181165 1.75792 0.180265 2.92458L0.172753 12.6662C0.171853 13.8329 1.10447 14.7656 2.27113 14.7648L12.0128 14.7578C13.1795 14.757 14.1135 13.823 14.1144 12.6563L14.1219 2.91465C14.1812 1.74794 13.2485 0.81527 12.0819 0.816102Z"
          fill="#F2F2F2"
        />
        <path
          d="M7.17471 10.0362C6.99971 10.0364 6.88304 10.0364 6.76651 9.86153L3.50236 6.59719C3.26921 6.36403 3.26948 6.01403 3.50299 5.78053C3.7365 5.54703 4.0865 5.54678 4.31966 5.77994L7.17578 8.63624L10.0363 5.77587C10.2698 5.54237 10.6198 5.54212 10.853 5.77529C11.0861 6.00845 11.0859 6.35845 10.8524 6.59195L7.58317 9.86095C7.46642 9.9777 7.29137 10.0362 7.17471 10.0362Z"
          fill={fillColor ?? "#333333"}
        />
      </g>
      <defs>
        <clipPath id="clip0_2415_796">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="matrix(1 -0.000712849 -0.000771177 1 0.181885 0.824585)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
